import React, { useEffect, useState } from 'react';

const CategoryNav = () => {

    const [category,setCategory]=useState([])
    useEffect(()=>{
        fetch('https://spooky-journalist-server.vercel.app/services')
    .then(res=>res.json())
    .then(data=>setCategory(data));
    },[])

    return (
        <div  className="grid grid-cols-2 md:grid-cols-5 gap-3 px-6 md:px-20 mb-8">
{
  category.map(service=>
  <div className="">
  <h2  key={service._id} className="bg-slate-200 rounded-md h-12 p-3 align-middle">{service.title}</h2>
  </div>)
}
</div>
    );
};

export default CategoryNav;